/**
 * Loads a JavaScript file and returns a Promise for when it is loaded
 */

export function loadScript(src) {
    window.soScriptsLoaded = window.soScriptsLoaded || [];
    const alreadyLoaded = window.soScriptsLoaded.includes(src);

    if (!alreadyLoaded) {
        window.soScriptsLoaded.push(src);
    }

    return new Promise((resolve, reject) => {
        if (!alreadyLoaded) {
            const script = document.createElement("script");
            script.type = "text/javascript";
            script.onload = resolve;
            script.onerror = reject;
            script.src = src;
            document.head.append(script);
        } else {
            resolve();
        }
    });
}
